import { transform } from './mapper.js'

const item = def => ({
  text: def.question,
  linkId: def.name
})

const responsePath = def => [ 'item', item(def), 'answer', 0, def.fhirType ]

const mkResponseMapping = questionDefinition => ({
  fhir: responsePath(questionDefinition),
  form: [ questionDefinition.name ]
})

const baseMapping = [
  {
    fhir: [ 'resourceType' ],
    fhir_const: 'QuestionnaireResponse'
  },
  {
    fhir: [ 'status' ],
    fhir_const: 'complete'
  }
]

const generateMapping = mapping => [
  ...baseMapping,
  ...Object.keys(mapping).map(m => mkResponseMapping(mapping[m]))
]

export const map = (
  form,
  patientId,
  userId,
  category,
  encounterId,
  mapping
) => {
  const res = transform(form, generateMapping(mapping), [ 'form', 'fhir' ])
  res.subject = { reference: `Patient/${patientId}` }
  res.questionnaire = {
    reference: `http://narus.com/Questionnaire/${category}`
  }
  res.author = { reference: `Practitioner/${userId}` }
  res.context = { reference: `Encounter/${encounterId}` }
  res.authored = new Date()
  return res
}

export const unmap = (data, mapping) =>
  transform(data, generateMapping(mapping), [ 'fhir', 'form' ])
